import { Emitter } from './emitter';

// 端末の鍵（login が返す token）。PIN は保存しない。鍵は24時間で切れ、切れたらログインからやり直す
export interface SessionInfo {
  token: string;
  team_id: string;
  team_name: string;
  server_id: string;
  event_id: string;
  terms_version: string;
  terms_accepted: boolean;
  saved_at: number;
}

const KEY = 'waggle.session.v1';
const DEVICE_KEY = 'waggle.device.v1';
const TTL_MS = 23.5 * 60 * 60 * 1000;

function read<T>(k: string): T | null {
  try {
    const s = localStorage.getItem(k);
    return s ? (JSON.parse(s) as T) : null;
  } catch {
    return null;
  }
}

class Session {
  readonly changed = new Emitter<SessionInfo | null>();
  private info: SessionInfo | null = read<SessionInfo>(KEY);

  constructor() {
    if (this.info && Date.now() - this.info.saved_at > TTL_MS) this.clear();
  }

  /** 端末ごとの識別子。ログインし直しても変えない（同意と位置の記録を端末で束ねるため） */
  deviceId(): string {
    let id: string | null = null;
    try {
      id = localStorage.getItem(DEVICE_KEY);
      if (!id) {
        id = crypto.randomUUID();
        localStorage.setItem(DEVICE_KEY, id);
      }
    } catch {
      id ??= crypto.randomUUID();
    }
    return id;
  }

  get(): SessionInfo | null {
    return this.info;
  }
  token(): string | null {
    return this.info?.token ?? null;
  }
  set(info: Omit<SessionInfo, 'saved_at'>): void {
    this.info = { ...info, saved_at: Date.now() };
    try {
      localStorage.setItem(KEY, JSON.stringify(this.info));
    } catch {
      /* 保存できなくても今の画面では使える */
    }
    this.changed.emit(this.info);
  }
  markTermsAccepted(): void {
    if (this.info) this.set({ ...this.info, terms_accepted: true });
  }
  clear(): void {
    this.info = null;
    try {
      localStorage.removeItem(KEY);
    } catch {
      /* noop */
    }
  }
  /** サーバーが invalid_session を返した */
  expire(): void {
    if (!this.info) return;
    this.clear();
    this.changed.emit(null);
  }
}

export const session = new Session();
